import type { ReactNode } from 'react';

export interface EyebrowProps {
  children: ReactNode;
  /** Render in the magenta tint instead of the default mint. */
  magenta?: boolean;
}

export function Eyebrow({ children, magenta }: EyebrowProps) {
  return (
    <span className="aw-eyebrow" style={magenta ? { color: 'var(--aw-magenta-soft)' } : undefined}>
      {children}
    </span>
  );
}
